// extracted by mini-css-extract-plugin
export default {"block":"pzuNgZ","block__linkRow":"IzBwqm"};